import React from "react";
import classNames from "classnames";
import './FormSection.scss';
import { hasValue } from "uxp/components";

export const FormSection: React.FC<{ label: string, error?: string, inputMinWidth?: string | number,labelPosition?:'top'|'center' }> = (props) => {

    const { label, error } = props

    const styles: React.CSSProperties = {}
    if (hasValue(props.inputMinWidth)) {
        styles.minWidth = props.inputMinWidth
    }

    return <div className={classNames("lucy-query-editor-form-field", { 'has-error': hasValue(error) })}>
        <div className={classNames("lucy-query-editor-form-field-content",{'label-top':props.labelPosition=='top'})}>
            <div className="lucy-query-editor-form-field-label">{label}</div>
            <div className="lucy-query-editor-form-field-input" style={styles} >{props.children}</div>
        </div>
        {hasValue(error) && <div className="lucy-query-editor-form-field-error">{error}</div>}
    </div>
}